import React, { useState } from 'react';
import {CalendlyModal} from "~/components/elements/CalendlyModal";

export const StepsWithDescription = (props) => {
    const { heading, shortDescription, steps } = props;
    
  return (
    <section className="bg-[rgba(246,249,255,1)] py-[6rem] px-4 text-[#25294B] text-center font-sans">
      <div className="main-content-section max-w-6xl mx-auto">
        <p className="uppercase tracking-widest text-[#4A6CF7] font-medium mb-2 text-[15px] text-[#4E86F5] not-italic font-black">
          {heading && heading.subHeading ? heading.subHeading : "HOW IT WORKS"}
        </p>
        <h2 className="text-[42px] font-bold mb-4 pt-stepDesc-title">
          {heading}
        </h2>
        {shortDescription && (
          <div
            className="text-[rgb(82, 82, 91)] !text-[19px] mb-12 pt-short-p"
            dangerouslySetInnerHTML={{ __html: shortDescription }}
          />
        )}

        <div className="space-y-8 md:space-y-14 pt-customers">
          {steps.map((step, idx) => {
            const type = step?.stepLink?.type;

            const link = step?.stepLink?.link;
            const [modalOpen, setModalOpen] = useState(false);   
            const buttonUrl = link?.url ?? null;
            const isPrimary = idx === 0;
            const isCalendly = type === "calendly";

            const handleCalendlyClick = (e) => {
              e.preventDefault();
              if (typeof window !== "undefined" && window.Calendly) {
                window.Calendly.initPopupWidget({ url: buttonUrl });
              }
            };
            return (
            <div
              key={idx}
              className="flex flex-col md:flex-row items-start  gap-10 text-left"
            >
              <img
                src={step.image.localFile.publicURL}
                alt={step.image.altText || `Step ${idx + 1}`}
                className="w-[182px] h-[182px] object-cover rounded-full mx-auto md:mx-0"
              />
              <div className="pt-right-content">
                <div className="flex flex-col gap-4">
                  <span className="w-6 h-6 text-sm font-bold rounded-full bg-[#E5EBFB] text-[#4A6CF7] flex items-center justify-center mr-3 pt-list-item-icon">
                    {idx + 1}
                  </span>
                  <h3 className="text-base md:text-lg font-semibold text-[#25294B]">
                    {step.heading}
                  </h3>
                </div>
                <p className="text-[#6B7280] text-sm md:text-[15px] leading-relaxed mt-5">
                  {step.content}
                </p>
                {buttonUrl && (
                  <>

                    {isCalendly ? (
                      <>
                        <div className="mt-4 pt-appointment-button">
                          <CalendlyModal isOpen={modalOpen} onClose={() => setModalOpen(false)} calendlyUrl={buttonUrl} />
                          <button key={idx} onClick={() => setModalOpen(true)} className={`rounded-full px-6 py-3 text-[16px] transition-all duration-300`}>
                            {step?.stepLink?.link?.title}
                          </button>
                        </div>
                      </>

                    ) : (
                      <div className="mt-4 pt-appointment-button">
                        <a key={idx} href={buttonUrl} className={`rounded-full px-6 py-3 text-[20px] transition-all duration-300`}>
                          {step?.stepLink?.link?.title}
                        </a>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};